var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.592,
    height: 16.801,
    viewBox: "0 0 13.592 16.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48.886)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.886)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.259,2.921a6.783,6.783,0,0,0-11.153,0,6.785,6.785,0,0,0-.79,6.251A5.343,5.343,0,0,0,50.3,10.8l4.934,5.8a.587.587,0,0,0,.894,0L61.062,10.8a5.348,5.348,0,0,0,.985-1.624A6.786,6.786,0,0,0,61.259,2.921Zm-.312,5.843a4.19,4.19,0,0,1-.775,1.269l0,0-4.487,5.27-4.49-5.274a4.193,4.193,0,0,1-.776-1.273,5.612,5.612,0,0,1,.656-5.171,5.609,5.609,0,0,1,9.22,0A5.613,5.613,0,0,1,60.947,8.764Z",
    transform: "translate(-48.886)",
    fill: "current"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.393 3.485)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.044,106.219a3.29,3.29,0,1,0,3.29,3.29A3.293,3.293,0,0,0,159.044,106.219Zm0,5.4a2.115,2.115,0,1,1,2.115-2.115A2.117,2.117,0,0,1,159.044,111.623Z",
    transform: "translate(-155.754 -106.219)",
    fill: "current"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.0e737181d5209cd56722623422ae8fb0.svg";
export { ForwardRef as ReactComponent };